import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { Link, Redirect } from 'react-router-dom';
import sessionConstants from '../../constants/SessionConstants';
import { userLogoutRequestSynch } from '../../actions/LogoutActions';
import { getUserInfo } from '../../shared/requests/UserInfoRequests';
import MySnackbarContentWrapper from '../../shared/snackbars/MySnackbarContentWrapper';
import {
  getCart,
  getLines,
  getLine,
  removeProductFromCart,
  updateQuantity,
  updateCartDiscount,
} from '../../shared/requests/shop/CartRequests';
import {
  productSortByID,
  lineSortByID,
} from '../../shared/Helpers';
import productPlaceholder from '../../static/img/product_placeholder.jpg';

const styles = theme => ({
  header: {
    textAlign: 'center',
    margin: theme.spacing(5),
  },
  loadingSpinner: {
    margin: theme.spacing(3),
  },
  paper: {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: 800,
    padding: theme.spacing(3),
    margin: theme.spacing(3),
  },
  media: {
    width: '100%',
    padding: theme.spacing(2),
  },
  cardActions: {
    margin: theme.spacing(),
    justifyContent: 'center',
  },
  sectionTitle: {
    marginBottom: theme.spacing(3),
  },
  buttonAndPrice: {
    display: 'flex',
  },
  headerPrice: {
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(),
  },
  headerQuantity: {
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(),
  },
  headerTotal: {
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(),
    paddingRight: theme.spacing(),
  },
  button: {
    margin: theme.spacing(2),
  },
  productImage: {
    height: 80,
    width: 80,
  },
  price: {
    padding: theme.spacing(),
  },
  noPaddingBottom: {
    paddingBottom: 0,
  },
  inline: {
    display: 'inline',
  },
  padBottom: {
    marginBottom: theme.spacing(2),
  },
  padTop: {
    marginTop: theme.spacing(2),
  },
  subtotalContainer: {
    textAlign: 'right',
    margin: theme.spacing(3),
  },
  discountContainer: {
    float: 'left',
    margin: theme.spacing(3),
  },
  discountButton: {
    margin: theme.spacing(),
  },
  dividers: {
    margin: theme.spacing(),
  },
  padDiscountButton: {
    margin: theme.spacing(),
    marginRight: theme.spacing(6),
  },
});

class Cart extends React.Component {
  constructor(props) {
    super(props);
    const { id } = this.props;

    this.state = {
      loading: true,
      lineLoading: null,
      discountLoading: false,
      snackbarOpen: false,
      snackbarVariant: '',
      snackbarMessage: '',
      cart: null,
      lines: [],
      products: [],
      discountCode: '',
      redirect: !id,
      redirectReason: sessionConstants.LOGIN_REQUIRED,
    };

    this.handleClose = this.handleClose.bind(this);
    this.removeProductFromCart = this.removeProductFromCart.bind(this);
    this.updateQuantity = this.updateQuantity.bind(this);
    this.applyDiscount = this.applyDiscount.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const {
      token,
      id,
      dispatch,
    } = this.props;

    if (id) {
      // Check if token is active, redirect to login if it is rotten
      getUserInfo(token, id)
        .catch((error) => {
          if (error.response && error.response.status === 403) {
            userLogoutRequestSynch(token)(dispatch)
              .then(() => this.setState({ redirect: true, redirectReason: sessionConstants.SESSION_EXPIRED }));
          }
        });
      // get cart
      getCart(token) // get cart
        .then((response) => {
          console.log('got cart');
          console.log(response.data);
          this.setState({
            cart: response.data,
          });
          getLines(token, this.state.cart.lines) // get cart lines
            .then((response) => {
              console.log('got cart lines');
              console.log(response.data);
              if (response.data.length < 1) {
                this.setState({
                  lines: lineSortByID(response.data),
                  loading: false,
                });
              } else {
                this.setState({
                  lines: lineSortByID(response.data),
                });
                response.data.forEach(line => (
                  getLine(token, line.product) // get each individual line product
                    .then((response) => {
                      console.log('got single product');
                      console.log(response.data);
                      this.setState({
                        products: productSortByID(this.state.products.concat([response.data])),
                        loading: false,
                      });
                    })
                    .catch((error) => {
                      // console.log(error);
                      this.setState({
                        snackbarOpen: true,
                        snackbarVariant: 'error',
                        snackbarMessage: 'Failed to load line item',
                        loading: false,
                      });
                    })
                ));
              }
            })
            .catch((error) => {
              // console.log(error);
              this.setState({
                snackbarOpen: true,
                snackbarVariant: 'error',
                snackbarMessage: 'Failed to load lines',
                loading: false,
              });
            });
        })
        .catch((error) => {
          // console.log(error);
          this.setState({
            snackbarOpen: true,
            snackbarVariant: 'error',
            snackbarMessage: 'Failed to load cart',
            loading: false,
          });
        });
    }
  }

  handleChange(e) {
    this.setState({
      discountCode: e.target.value.toUpperCase(),

    });
  }

  removeProductFromCart(e, lineUrl, i) {
    const { token } = this.props;
    this.setState({ lineLoading: i });
    removeProductFromCart(token, lineUrl)
      .then((response) => {
        // console.log('REMOVED PRODUCT:');
        // console.log(response.data);
        this.setState({
          snackbarOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: 'Product removed from cart',
        });
        getCart(token) // get cart
          .then((response) => {
            // console.log('CART:');
            // console.log(response.data);
            this.setState({
              cart: response.data,
            });
            getLines(token, this.state.cart.lines) // get cart lines
              .then((response) => {
                // console.log('LINES:');
                // console.log(response.data);
                this.setState({
                  lines: response.data,
                  products: [], // empty products array for rebuilding
                });
                response.data.map(line => (
                  getLine(token, line.product) // get each individual line product
                    .then((response) => {
                      // console.log(response.data);
                      this.setState({
                        products: this.state.products.concat([response.data]),
                        lineLoading: null,
                      });
                    })
                    .catch((error) => {
                      // console.log(error);
                      this.setState({
                        snackbarOpen: true,
                        snackbarVariant: 'error',
                        snackbarMessage: 'Failed to load line item',
                        lineLoading: null,
                      });
                    })
                ));
              })
              .catch((error) => {
                // console.log(error);
                this.setState({
                  snackbarOpen: true,
                  snackbarVariant: 'error',
                  snackbarMessage: 'Failed to load lines',
                  lineLoading: null,
                });
              });
          })
          .catch((error) => {
            // console.log(error);
            this.setState({
              snackbarOpen: true,
              snackbarVariant: 'error',
              snackbarMessage: 'Failed to load cart',
              lineLoading: null,
            });
          });
      })
      .catch((error) => {
        // console.log(error);
        this.setState({
          snackbarOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: 'Failed to remove product',
          lineLoading: null,
        });
      });
  }

  applyDiscount() {
    const { token } = this.props;
    const { discountCode, cart } = this.state;
    this.setState({
      discountLoading: true,
    });
    updateCartDiscount(token, discountCode, cart.id)
      .then((response) => {
        // console.log('DISCOUNT:');
        // console.log(response);
        this.setState({
          snackbarOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: 'Coupon claimed!',
          discountCode: '',
          discountLoading: false,
        });
        getCart(token) // get cart
          .then((response) => {
            // console.log('CART:');
            // console.log(response.data);
            this.setState({
              cart: response.data,
            });
          })
          .catch((error) => {
            // console.log(error);
            this.setState({
              snackbarOpen: true,
              snackbarVariant: 'error',
              snackbarMessage: 'Failed to load cart',
              discountLoading: false,
            });
          });
      })
      .catch((error) => {
        console.log('failed to add discount');
        console.log(error.response);
        this.setState({
          snackbarOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: 'Failed to add discount',
          discountLoading: false,
        });
      });
  }

  updateQuantity(e, lineUrl, i) {
    const { token } = this.props;
    this.setState({ lineLoading: i });
    updateQuantity(token, e.target.value, lineUrl)
      .then((response) => {
        // console.log('UPDATE QUANTITY:');
        // console.log(response.data);
        getCart(token) // get cart
          .then((response) => {
            // console.log('CART:');
            // console.log(response.data);
            this.setState({
              cart: response.data,
            });
            getLines(token, this.state.cart.lines) // get cart lines
              .then((response) => {
                // console.log('LINES:');
                // console.log(response.data);
                this.setState({
                  lines: response.data,
                  snackbarOpen: true,
                  snackbarVariant: 'success',
                  snackbarMessage: 'Quantity updated',
                  lineLoading: false,
                });
              })
              .catch((error) => {
                // console.log(error);
                this.setState({
                  snackbarOpen: true,
                  snackbarVariant: 'error',
                  snackbarMessage: 'Failed to load cart lines',
                  lineLoading: false,
                });
              });
          })
          .catch((error) => {
            // console.log(error);
            this.setState({
              snackbarOpen: true,
              snackbarVariant: 'error',
              snackbarMessage: 'Failed to load cart',
              lineLoading: false,
            });
          });
      })
      .catch((error) => {
        // console.log(error);
        this.setState({
          snackbarOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: 'Failed to update product quantity',
          lineLoading: false,
        });
      });
  }

  handleClose(e, reason) {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackbarOpen: false });
  }

  render() {
    const {
      classes,
      location: {
        pathname,
      },
    } = this.props;

    const {
      loading,
      cart,
      lines,
      products,
      discountCode,
      snackbarOpen,
      snackbarVariant,
      snackbarMessage,
      lineLoading,
      discountLoading,
      redirect,
      redirectReason,
    } = this.state;

    function renderMenuItems() {
      let i;
      const ret = [];
      for (i = 1; i < 60; i += 1) {
        ret.push(<MenuItem key={i} value={i}>{i}</MenuItem>);
      }
      return ret;
    }
    function isCartEmpty() {
      if (lines.length < 1) {
        return true;
      }
      return false;
    }

    function displayOfferDiscounts() {
      if (!cart) {
        return null;
      }
      return (
        <React.Fragment>
          {cart.offer_discounts.map(item => (
            <Typography key={item.name}>{item.name + ': -' + item.amount}</Typography>
          ))}
        </React.Fragment>
      );
    }

    function displayVoucherDiscounts() {
      if (!cart) {
        return null;
      }
      return (
        <React.Fragment>
          {cart.voucher_discounts.map(item => (
            <Typography key={item.name}>{item.name + ': -' + item.amount}</Typography>
          ))}
        </React.Fragment>
      );
    }

    // If no id when the component renders, component sent a logout request bc the token is expired. Reroute to login.
    if (redirect) {
      return (
        <Redirect to={`/login?to=${encodeURIComponent(pathname)}&reason=${encodeURIComponent(redirectReason)}`} />
      );
    }
    return (
      <React.Fragment>
        <Typography className={classes.header} color="textSecondary" variant="h4">Cart</Typography>
        {/* PRODUCTS DETAIL */}
        <Paper className={classes.paper}>
          {loading
            ? <CircularProgress color="secondary" className={classes.loadingSpinner} />
            : (
              <React.Fragment>
                {/* LINES */}
                <ListItem className={classes.noPaddingBottom}>
                  <ListItemText>
                    <Typography variant="h6">Cart Summary</Typography>
                  </ListItemText>
                  <Typography className={classes.headerQuantity} variant="subtitle2">Quantity</Typography>
                  <Typography className={classes.headerPrice} variant="subtitle2">Price</Typography>
                  <Typography className={classes.headerTotal} variant="subtitle2">Total</Typography>
                </ListItem>
                <Divider className={classes.padBottom} />
                {!lines || lines.length < 1 || !cart
                  ? <Typography variant="body1">Your cart is currently empty</Typography>
                  : products.map((product, i) => (
                    <ListItem key={product.id}>
                      {product.images
                        ? <img alt="product" className={classes.productImage} src={product.images[0].original} />
                        : <img alt="product placeholder" className={classes.productImage} src={productPlaceholder} />
                      }
                      <ListItemText primary={product.title} />
                      {lineLoading === i && <CircularProgress color="secondary" />}
                      <Select
                        value={lines[i]
                          ? lines[i].quantity
                          : 1
                        }
                        className={classes.priceSelect}
                        onChange={e => this.updateQuantity(e, lines[i].url, i)}
                      >
                        {renderMenuItems()}
                      </Select>
                      <Tooltip title="remove from cart">
                        <IconButton onClick={e => this.removeProductFromCart(e, lines[i].url, i)}>
                          <DeleteForeverIcon color="secondary" />
                        </IconButton>
                      </Tooltip>
                      <Typography className={classes.price} variant="body2" color="textSecondary">{'$' + product.price.excl_tax}</Typography>
                      <Typography className={classes.price} vairnat="body2">{'$' + lines[i].price_excl_tax}</Typography>
                    </ListItem>
                  ))
                }
                <Divider className={classes.padTop} />
                <Grid container justifyContent="center">
                  <Grid item className={classes.discountContainer}>
                    <TextField
                      onChange={this.handleChange}
                      value={discountCode}
                      label="Discount Code"
                      variant="outlined"
                    />
                    <Button
                      className={discountLoading ? classes.discountButton : classes.padDiscountButton}
                      variant={discountCode ? 'contained' : 'outlined'}
                      color="secondary"
                      onClick={this.applyDiscount}
                    >
                      Apply
                    </Button>
                    {discountLoading && <CircularProgress color="secondary" />}
                  </Grid>
                  <Grid className={classes.subtotalContainer} item>
                    <Typography className={classes.inline} variant="h6">Cart Total: </Typography>
                    {!lines || lines.length < 1 || !cart
                      ? <Typography className={classes.inline} variant="h6" color="secondary">$0.00</Typography>
                      : <Typography className={classes.inline} variant="h6" color="secondary">{'$' + cart.total_excl_tax_excl_discounts}</Typography>
                    }
                    <Divider className={classes.dividers} />
                    {displayOfferDiscounts()}
                    {displayVoucherDiscounts()}
                    <Divider className={classes.dividers} />
                    <Typography className={classes.inline} variant="h5">Subtotal: </Typography>
                    {!lines || lines.length < 1 || !cart
                      ? <Typography className={classes.inline} variant="h5" color="secondary">$0.00</Typography>
                      : <Typography className={classes.inline} variant="h5" color="secondary">{'$' + cart.total_excl_tax}</Typography>
                    }
                  </Grid>
                </Grid>
                <Grid container justifyContent="space-between">
                  <Grid item>
                    <Button component={Link} to="/shop/music">Continue Shopping</Button>
                  </Grid>
                  <Grid item>
                    <Button disabled={isCartEmpty()} component={Link} to="/shop/checkout" variant="contained" color="secondary">Checkout</Button>
                  </Grid>
                </Grid>
              </React.Fragment>
            )
          }
        </Paper>

        {/* SNACKBAR */}
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={!loading && snackbarOpen}
          autoHideDuration={5000}
          onClose={this.handleClose}
        >
          <MySnackbarContentWrapper
            onClose={this.handleClose}
            variant={snackbarVariant}
            message={snackbarMessage}
          />
        </Snackbar>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const {
    token,
    user,
  } = state.loginReducer;
  const id = user && user.id; // Nullcheck user and get id.

  return {
    token,
    id,
  };
}

Cart.propTypes = {
  token: PropTypes.string,
  id: PropTypes.number,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  dispatch: PropTypes.func.isRequired,
};

Cart.defaultProps = {
  token: undefined,
  id: undefined,
  location: undefined,
};

export default withStyles(styles)(connect(mapStateToProps)(Cart));
